module.exports = __webpack_public_path__ + "img/printer.5afcb705.svg";